import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ServicehotelService } from 'src/app/api/config/servicehotel.service';
import AlertifyHelper from 'src/app/utils/utils';
import { constants } from 'src/app/constants';
import { ToolsService } from 'src/app/utils/tools.service';
import { GlobalService } from 'src/app/api/global.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import { BookingsService } from 'src/app/api/booking/bookings.service';
import { Router } from '@angular/router';
import { GroupService } from 'src/app/api/departure/group.service';
declare var $: any;

@Component({
  selector: 'app-group-detail-extends',
  templateUrl: './group-detail-extends.component.html',
  styleUrls: ['./group-detail-extends.component.css']
})
export class GroupDetailExtendsComponent {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @Output() onSubmitEvent = new EventEmitter<string>();

  branchofficeSlug: string = '';
  item: FormGroup;
  submitted: boolean = false;

  // variables
  checkId:any = null;
  book: any = null;
  bookings: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    public toolsService: ToolsService,
    private bookingsService: BookingsService,
    private groupService: GroupService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]]
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  focused() {
    setTimeout(() => {
      (<any>$('#item_description')).focus();
    }, 500);
  }

  init(group_id: any) {
    this.LoadingModalComponent.show();    
    this.checkId = group_id;
    this.editData();
   
  }

  editData() {
    this.groupService.detail(this.checkId).subscribe({
      next: (data: any) => {
        let result = data.data;
        this.book = result.book;
        this.bookings = result.bookings;
        this.LoadingModalComponent.hide();
      }
    });
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
    this.book = null;
    
  }

  close() {
    this.item.reset();

  }

}
